module.exports = __webpack_public_path__ + "static/media/Gosch_Logo_RGB-1980x426.013e3a62.jpg";